import React, { useEffect, useState, createElement } from 'react';
import { CountdownBanner } from '../components/CountdownBanner';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { TrustBar } from '../components/TrustBar';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ValueStack } from '../components/ValueStack';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { motion, AnimatePresence } from 'framer-motion';
export function LandingPage() {
  const [showMobileCTA, setShowMobileCTA] = useState(false);
  const [selectedBumps, setSelectedBumps] = useState<number[]>([]);
  // Meta Pixel initialization + PageView
  useEffect(() => {
    if (!(window as any).fbq) {
      const f = window as any;
      const n = f.fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    ;
    (window as any).fbq('init', '1621195905759908');
    (window as any).fbq('track', 'PageView');
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      // Show mobile CTA after scrolling down 500px
      if (window.scrollY > 500) {
        setShowMobileCTA(true);
      } else {
        setShowMobileCTA(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToPricing = () => {
    const element = document.getElementById('pricing');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-navy-900 selection:bg-gold/30 selection:text-navy overflow-x-hidden" data-id="element-272">
      <CountdownBanner data-id="element-273" />
      <Navbar data-id="element-274" />

      <main data-id="element-275">
        <HeroSection data-id="element-276" />
        <TrustBar data-id="element-277" />
        <ProblemSection data-id="element-278" />
        <SolutionSection data-id="element-279" />
        <ValueStack selectedBumps={selectedBumps} setSelectedBumps={setSelectedBumps} data-id="element-280" />
        <Testimonials data-id="element-281" />
        <FAQ data-id="element-282" />
      </main>

      <Footer data-id="element-283" />

      <SocialProofPopup data-id="element-284" />

      {/* Mobile Sticky CTA */}
      <AnimatePresence data-id="element-285">
        {showMobileCTA && <motion.div initial={{
        y: 100
      }} animate={{
        y: 0
      }} exit={{
        y: 100
      }} className="fixed bottom-0 left-0 right-0 p-4 bg-navy/95 backdrop-blur-md border-t border-white/10 shadow-[0_-10px_20px_rgba(0,0,0,0.3)] z-40 md:hidden" data-id="element-286">
            <a href={(() => {
          const base = 'https://manosquegeneran.com/cart/';
          const has0 = selectedBumps.includes(0);
          const has1 = selectedBumps.includes(1);
          const has2 = selectedBumps.includes(2);
          if (!has0 && !has1 && !has2) return base + '48451070951651:1';
          if (has0 && has1 && has2) return base + '48451101327587:1';
          if (has0 && has1) return base + '48511860179171:1';
          if (has0 && has2) return base + '48512362250467:1';
          if (has1 && has2) return base + '48512736526563:1';
          if (has0) return base + '48451091529955:1';
          if (has1) return base + '48451095789795:1';
          if (has2) return base + '48451096871139:1';
          return base + '48451070951651:1';
        })()} target="_blank" rel="noopener noreferrer" onClick={() => {
          if ((window as any).fbq) {
            ;
            (window as any).fbq('track', 'AddToCart', {
              value: 6.36 + selectedBumps.length * 9,
              currency: 'USD',
              content_name: 'Imperio Americano',
              content_type: 'product',
              num_items: 1 + selectedBumps.length
            });
          }
        }} className="w-full py-4 bg-gold hover:bg-gold-dark text-navy font-heading font-bold text-lg rounded-lg shadow-lg flex items-center justify-center" data-id="element-287">
              Comprar Ahora - ${(6.36 + selectedBumps.length * 9).toFixed(2)}
            </a>
          </motion.div>}
      </AnimatePresence>
    </div>;
}